export default function loadGPTLibrary() {
  if (!window.googletag || !window.googletag.getVersion) {
    window.googletag = window.googletag || { cmd: [] };

    const tag = document.createElement('script');
    tag.id = 'gpt-library';
    tag.async = true;
    tag.type = 'text/javascript';
    tag.src = '//www.googletagservices.com/tag/js/gpt.js';
    document.head.appendChild(tag);
  }

  return window.googletag;
}

export function pubadsReady(timeout = 5000, frequency = 100) {
  return new Promise((resolve, reject) => {
    let duration = 0;
    const timerId = window.setInterval(() => {
      duration += frequency;
      if (window.googletag && window.googletag.pubadsReady) {
        window.clearInterval(timerId);
        resolve();
      } else if (duration > timeout) {
        window.clearInterval(timerId);
        reject();
      }
    }, frequency);
  });
}

export function prepareGPT() {
  if (!window.googletag || !window.googletag.getVersion) {
    window.googletag = window.googletag || { cmd: [] };
  }
}
